const CRM_MENU_ITEMS = [
  { key: 'board', to: '/crm', labelKey: 'crm.menu.board', fullLabelKey: 'crm.menuLabel', access: 'canAccessCRM' },
  { key: 'conversions', to: '/crm/conversions', labelKey: 'crm.menu.conversions', fullLabelKey: 'crm.conversionsMenuLabel', access: 'canAccessCRMDashboard' },
  { key: 'reports', to: '/crm/reports', labelKey: 'crm.menu.reports', fullLabelKey: 'crm.reportsMenuLabel', access: 'canAccessCRMReports' },
  { key: 'settings', to: '/crm/settings', labelKey: 'crm.menu.settings', fullLabelKey: 'crm.actions.openSettings', access: 'canAccessCRMSettings' },
]

export const getCrmMenuItems = permissions => CRM_MENU_ITEMS.filter(item => Boolean(permissions?.[item.access]))

export const isCrmPath = path => path === '/crm' || String(path || '').startsWith('/crm/')

export const isCrmMenuItemActive = (item, path) => {
  const currentPath = String(path || '').replace(/\/+$/, '') || '/'

  if (item.to === '/crm') {
    return currentPath === '/crm'
  }

  return currentPath === item.to || currentPath.startsWith(`${item.to}/`)
}
